import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {AdjustmentTypes, GroupMemberAdjustment} from '../../../graphql/groups.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
        maxWidth: '90vw'
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    adjustments: GroupMemberAdjustment[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    selectedAdjustment?: GroupMemberAdjustment,
    setSelectedAdjustment?: (adjustment: GroupMemberAdjustment) => void,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedAdjustment, setSelectedAdjustment, adjustments, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title={'Adjustments'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table style={{width: '100%'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: 50}}>Id</TableCell>
                                        <TableCell style={{width: 200}}>Type</TableCell>
                                        <TableCell style={{width: 100}}>Amount</TableCell>
                                        <TableCell>Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {adjustments.map(adjustment => {
                                        return (
                                            <TableRow
                                                hover
                                                key={adjustment.id}
                                                selected={selectedAdjustment === adjustment}
                                                onClick={() => setSelectedAdjustment ? setSelectedAdjustment(adjustment) : history.push('/adjustments/' + adjustment.id)}
                                            >
                                                <TableCell>{adjustment.id}</TableCell>
                                                <TableCell>{AdjustmentTypes[adjustment.adjustment_type!].name}</TableCell>
                                                <TableCell>${adjustment.amount}</TableCell>
                                                <TableCell>{adjustment.description}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                {paginatorInfo && rowsPerPage && (
                    <CardActions className={classes.actions}>
                        <TablePagination
                            component="div"
                            count={paginatorInfo.total}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            page={paginatorInfo.currentPage - 1}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </CardActions>
                )}
            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
